import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as LogoIcon } from '../../../../assets/images/logos/logo.svg';

function Logo() {
  return (
    <Link to='/' className='nav__logo-link'>
      <div className='nav__logo-content'>
        <LogoIcon className='nav__logo' />
        <div className='nav__logo-title'>HostAI</div>
      </div>
    </Link>
  );
}

export default Logo;
